/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
 * Запрос на сброс пароля пользователя, первая фаза. Отправка OTP.
 */
export interface UserResetPasswordSendOtpRequestV2 {
  /** Логин пользователя */
  login: string;

  /** Пароль пользователя */
  password: string;
}

/**
 * Объект описания ошибки
 */
export interface ErrorResponse {
  /**
   * Код ошибки
   * @example GENERAL_ERROR
   */
  errorCode?: string;

  /**
   * Сообщение об ошибке
   * @example Произошла непредвиденная ошибка
   */
  errorMessage?: string;
}

/**
 * Ответ на сброс пароля пользователя, первая фаза. Отправка OTP
 */
export interface UserResetPasswordSendOtpResponseV2 {
  /** Маскированный номер телефона */
  maskedPhoneNumber: string;

  /**
   * Задержка перед отправкой следующего OTP
   * @format int32
   */
  nextOtpReqDelay: number;
}

/**
 * Запрос на восстановление пароля пользователя, первая фаза. Отправка OTP.
 */
export interface UserRestorePasswordSendOtpRequest {
  /** Логин пользователя */
  login: string;
}

/**
 * Запрос проверки
 */
export interface UserVerificationSendOtpRequest {
  /** Логин пользователя */
  login: string;

  /** инн */
  inn: string;

  /** Фамилия */
  surname: string;
}

/**
 * Ответ проверки
 */
export interface UserVerificationSendOtpResponse {
  /** Номер телефона пользователя, на который отправляется sms-пароль. */
  maskedPhoneNumber: string;

  /**
   * Задержка перед повторной отправки кода
   * @format int32
   */
  nextRequestDelay: number;
}

/**
 * Запрос на сброс пароля пользователя, первая фаза. Отправка OTP.
 */
export interface UserResetPasswordSendOtpRequest {
  /** Логин пользователя */
  login: string;
}

/**
 * Запрос на сброс пароля пользователя, вторая фаза. Проверка OTP.
 */
export interface UserResetPasswordCheckOtpRequest {
  /** Логин пользователя */
  login: string;

  /** Новый пароль пользователя */
  password: string;

  /** Одноразовый пароль, полученный на первой фазе */
  otp: string;
}

export interface PC53RegisterMobileDeviceRequest {
  /** Наименование устройства */
  deviceName: string;

  /** Отпечаток устройства PayControl */
  fingerPrint: string;
}

export interface PC53RegisterMobileDeviceResponse {
  /** Ключевая информация для мобильного устройства */
  keyJson: string;

  /** Идентификатор пользователя в PayControl */
  payControlUserId: string;
}

export interface PC53LockPayControlUserRequest {
  /** Идентификатор пользователя в PayControl */
  payControlUserId: string;
}

/**
 * Запрос с информацией о способе сброса пароля
 */
export interface PasswordResetMethodRequest {
  /** Логин пользователя */
  login: string;

  /** ИНН */
  inn: string;
}

/**
 * Запрос на смену пароля пользователя
 */
export interface UserChangePasswordRequest {
  /** Старый пароль */
  oldPassword: string;

  /** Новый пароль */
  newPassword: string;
}

import { HttpClient } from "../../client";
import { ContentType, RequestParams } from "../../client/types";

/**
 * @title Микросервис users
 * @version 1.0
 * @license Все права защищены ООО РСХБ-ИНТЕХ
 * @baseUrl http://localhost:8080
 * @contact ООО РСХБ-ИНТЕХ, РДБО ЮЛ, Учетные записи <info@rshbintech.ru> (https://rshbintech.ru/)
 */
export class Api<
  SecurityDataType extends unknown
> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags Внешний сервис учетных записей. Версия 2
     * @name ResetPasswordByUserSendOtp
     * @summary Сброс пароля пользователя. Отправка OTP.
     * @request POST:/api/users/external/v2/reset-password-by-user-send-otp
     */
    resetPasswordByUserSendOtp: (
      data: UserResetPasswordSendOtpRequestV2,
      params: RequestParams = {}
    ) =>
      this.request<UserResetPasswordSendOtpResponseV2, ErrorResponse>({
        path: `/api/users/external/v2/reset-password-by-user-send-otp`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Внешний сервис учетных записей
     * @name RestorePasswordByUserSendOtp
     * @summary Восстановление пароля пользователя по логину. Отправка OTP
     * @request POST:/api/users/external/v1/restore-password-by-user-send-otp
     */
    restorePasswordByUserSendOtp: (
      data: UserRestorePasswordSendOtpRequest,
      params: RequestParams = {}
    ) =>
      this.request<void, ErrorResponse>({
        path: `/api/users/external/v1/restore-password-by-user-send-otp`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Внешний сервис учетных записей
     * @name UserPreloginOtpVerification
     * @summary Проверка данных пользователя для сброса пароля в прелогин зоне и отправки ОТП
     * @request POST:/api/users/external/v1/reset-password-prelogin-user-verification
     */
    userPreloginOtpVerification: (
      data: UserVerificationSendOtpRequest,
      params: RequestParams = {}
    ) =>
      this.request<void, ErrorResponse>({
        path: `/api/users/external/v1/reset-password-prelogin-user-verification`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Внешний сервис учетных записей
     * @name UserVerificationSendOtp
     * @summary Проверка данных пользователя для сброса пароля в прелогин зоне и отправки ОТП
     * @request POST:/api/users/external/v1/reset-password-prelogin-send-otp
     */
    userVerificationSendOtp: (
      data: UserVerificationSendOtpRequest,
      params: RequestParams = {}
    ) =>
      this.request<UserVerificationSendOtpResponse, ErrorResponse>({
        path: `/api/users/external/v1/reset-password-prelogin-send-otp`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Внешний сервис учетных записей
     * @name ResetPasswordByUserSendOtp1
     * @summary Сброс пароля пользователя. Отправка OTP.
     * @request POST:/api/users/external/v1/reset-password-by-user-send-otp
     * @deprecated
     */
    resetPasswordByUserSendOtp1: (
      data: UserResetPasswordSendOtpRequest,
      params: RequestParams = {}
    ) =>
      this.request<void, ErrorResponse>({
        path: `/api/users/external/v1/reset-password-by-user-send-otp`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Внешний сервис учетных записей
     * @name ResetPasswordByUserCheckOtp
     * @summary Сброс пароля пользователя. Проверка OTP.
     * @request POST:/api/users/external/v1/reset-password-by-user-check-otp
     */
    resetPasswordByUserCheckOtp: (
      data: UserResetPasswordCheckOtpRequest,
      params: RequestParams = {}
    ) =>
      this.request<void, ErrorResponse>({
        path: `/api/users/external/v1/reset-password-by-user-check-otp`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Взаимодействие с PayControl 5.3
     * @name Pc53RegisterMobileDevicePost
     * @summary Регистрация мобильного устройства по отпечатку устройства PayControl 5.3
     * @request POST:/api/users/external/v1/pc53/pc53-register-mobile-device
     * @secure
     */
    pc53RegisterMobileDevicePost: (
      data: PC53RegisterMobileDeviceRequest,
      params: RequestParams = {}
    ) =>
      this.request<PC53RegisterMobileDeviceResponse, string>({
        path: `/api/users/external/v1/pc53/pc53-register-mobile-device`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Взаимодействие с PayControl 5.3
     * @name Pc53LockPayControlUserPost
     * @summary Блокировка пользователя в PayControl 5.3.
     * @request POST:/api/users/external/v1/pc53/pc53-lock-pay-control-user
     * @secure
     */
    pc53LockPayControlUserPost: (
      data: PC53LockPayControlUserRequest,
      params: RequestParams = {}
    ) =>
      this.request<void, string>({
        path: `/api/users/external/v1/pc53/pc53-lock-pay-control-user`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Внешний сервис учетных записей
     * @name PasswordResetMethod
     * @summary Определение способа сброса пароля
     * @request POST:/api/users/external/v1/password-reset-new-method
     */
    passwordResetMethod: (
      data: PasswordResetMethodRequest,
      params: RequestParams = {}
    ) =>
      this.request<void, ErrorResponse>({
        path: `/api/users/external/v1/password-reset-new-method`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Внешний сервис учетных записей
     * @name ChangePasswordByUser
     * @summary Изменение пароля пользователя
     * @request POST:/api/users/external/v1/change-password-by-user
     * @secure
     */
    changePasswordByUser: (
      data: UserChangePasswordRequest,
      params: RequestParams = {}
    ) =>
      this.request<void, ErrorResponse>({
        path: `/api/users/external/v1/change-password-by-user`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
}

export const api = new Api();
